/* eslint-disable no-console */
import {
  logEvent as SentryLogEvent,
  logError as SentryLogError,
} from '@/src/utils/sentry';

import { ERROR_LEVEL, INFO_LEVEL } from './constants';

export { setUserContext } from '@/src/utils/sentry';

export function logEvent(message) {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('[LOG_EVENT]: ', message);
    } else {
      SentryLogEvent(message);
    }
  } catch (err) {
    console.error(err);
  }
  return message;
}

export function logError(message, error) {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.error(message, error);
    } else {
      SentryLogError(message, error);
    }
  } catch (err) {
    console.error(err);
  }
  return message;
}

export { ERROR_LEVEL, INFO_LEVEL };
